var map = {
	"./laying-classica-off.svg": "f50f",
	"./laying-classica-on.svg": "aade",
	"./laying-classica.svg": "1d69",
	"./laying-diagonale-off.svg": "dae3",
	"./laying-diagonale-on.svg": "bb79",
	"./laying-diagonale.svg": "e8e1",
	"./laying-parquet-off.svg": "2176",
	"./laying-parquet-on.svg": "bb68",
	"./laying-parquet.svg": "fdff",
	"./laying-spaccamattone-off.svg": "1094",
	"./laying-spaccamattone-on.svg": "e303",
	"./laying-spaccamattone.svg": "a90f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc2f";